module.exports = __webpack_public_path__ + "static/media/coffeescript.f951912a.svg";